<template>
  <div class="card-body">
    <inputbox
      name="solicitor"
      label="Solicitor"
      helper="Please enter the Solicitor"
      v-model="form.solicitor"
      :show-error="form.errors.has('solicitor')"
      :error-message="form.errors.get('solicitor')"
    ></inputbox>

    <inputbox
      name="solicitor_reference"
      label="Solicitor Reference"
      helper="Please enter the Solicitors Reference"
      v-model="form.solicitor_reference"
      :show-error="form.errors.has('solicitor_reference')"
      :error-message="form.errors.get('solicitor_reference')"
    ></inputbox>

    <datepicker-input
      name="date_instructed"
      label="Date Instructed"
      helper="Please enter the date instructed"
      v-model="form.date_instructed"
    ></datepicker-input>

    <selectlist
      :options="claimsTrackOptions"
      label="Claims Track"
      name="claims_track"
      helper="Please select the claims track"
      placeholder="Please Select"
      label-name="label"
      key-name="id"
      v-model="form.claims_track"
      :show-error="form.errors.has('claims_track')"
      :error-message="form.errors.get('claims_track')"
    ></selectlist>

    <selectlist
      :options="escalationStageOptions"
      label="Escalation Stage"
      name="escalation_stage"
      helper="Please select the escalation stage"
      placeholder="Please Select"
      label-name="label"
      key-name="id"
      v-model="form.escalation_stage"
      :show-error="form.errors.has('escalation_stage')"
      :error-message="form.errors.get('escalation_stage')"
    ></selectlist>

    <div class="text-right mt-3">
      <form-button :indicator="processing" @clicked="submit">Save</form-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    section: {
      type: Object,
      default: null
    }
  },

  data() {
    return {
      processing: false,
      form: new window.Form({
        solicitor: null,
        solicitor_reference: null,
        date_instructed: null,
        claims_track: null,
        escalation_stage: null
      }),
      claimsTrackOptions: [
        { id: 'small', label: 'Small' },
        { id: 'fast', label: 'Fast' },
        { id: 'multi', label: 'Multi' }
      ],
      escalationStageOptions: [
        { id: 'pre_issue', label: 'Pre Issue' },
        { id: 'issued_awaiting_defence', label: 'Issued Awaiting Defence' },
        {
          id: 'issued_awaiting_allocation_court_directions',
          label: 'Issued Awaiting Allocation/Court Directions'
        },
        { id: 'issued_trial', label: 'Issued Trial' },
        { id: 'judgement_settlement', label: 'Judgement/Settlement' }
      ]
    };
  },

  watch: {
    section: {
      handler: 'hydrate',
      immediate: true
    }
  },

  methods: {
    hydrate(d) {
      if (!d) {
        return;
      }

      this.form.solicitor = d.solicitor;
      this.form.solicitor_reference = d.solicitor_reference;
      // The api returns the date as a utc iso string, so parse it back into
      // a date object to keep the datepicker in the users local timezone.
      this.form.date_instructed = d.date_instructed
        ? window.DateManager.parse(d.date_instructed)
        : null;
      this.form.claims_track = d.claims_track;
      this.form.escalation_stage = d.escalation_stage;
    },

    submit() {
      this.processing = true;

      this.form
        .put(`/debt-recovery/${this.incident}/solicitors`)
        .then(data => {
          this.processing = false;
          this.form.errors.clear();
          this.$emit('saved', data);
          window.toastify.success(
            'Success!',
            'The solicitor details were saved successfully!'
          );
        })
        .catch(() => {
          this.processing = false;
          window.toastify.error(
            'Error',
            'Sorry, there was an error saving the solicitor details'
          );
        });
    }
  }
};
</script>
